import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileActionBar } from "@/components/layout/MobileActionBar";
import { CartDrawer } from "@/components/layout/CartDrawer";
import { HomePage } from "@/pages/HomePage";
import { ShopPage } from "@/pages/ShopPage";
import { BookPage } from "@/pages/BookPage";
import { PartyPacksPage } from "@/pages/PartyPacksPage";
import { FlavorsPage } from "@/pages/FlavorsPage";
import { WholesalePage } from "@/pages/WholesalePage";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";
import { FaqPage } from "@/pages/FaqPage";
import { PolicyPage } from "@/pages/PolicyPage";
import { OrderSuccessPage, OrderCancelledPage } from "@/pages/OrderPages";
import { AdminLogin } from "@/pages/admin/AdminLogin";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { RetailerLogin } from "@/pages/retailer/RetailerLogin";
import { RetailerPortal } from "@/pages/retailer/RetailerPortal";
import { ResetPasswordPage } from "@/pages/ResetPassword";

const SmoothScroll = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return children;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <CartProvider>
                    <SmoothScroll>
                        <Header />
                        <main className="pb-16 md:pb-0">
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/shop" element={<ShopPage />} />
                                <Route path="/book" element={<BookPage />} />
                                <Route path="/party-packs" element={<PartyPacksPage />} />
                                <Route path="/flavors" element={<FlavorsPage />} />
                                <Route path="/wholesale" element={<WholesalePage />} />
                                <Route path="/about" element={<AboutPage />} />
                                <Route path="/contact" element={<ContactPage />} />
                                <Route path="/faq" element={<FaqPage />} />
                                <Route path="/privacy" element={<PolicyPage slug="privacy" fallbackTitle="Privacy Policy" />} />
                                <Route path="/terms" element={<PolicyPage slug="terms" fallbackTitle="Terms of Service" />} />
                                <Route path="/shipping" element={<PolicyPage slug="shipping" fallbackTitle="Shipping & Delivery" />} />
                                <Route path="/returns" element={<PolicyPage slug="returns" fallbackTitle="Returns & Refunds" />} />
                                <Route path="/accessibility" element={<PolicyPage slug="accessibility" fallbackTitle="Accessibility" />} />
                                <Route path="/order-success" element={<OrderSuccessPage />} />
                                <Route path="/order-cancelled" element={<OrderCancelledPage />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/retailer/login" element={<RetailerLogin />} />
                                <Route path="/retailer" element={<RetailerPortal />} />
                                <Route path="/admin/reset-password" element={<ResetPasswordPage portal="admin" />} />
                                <Route path="/retailer/reset-password" element={<ResetPasswordPage portal="retailer" />} />
                                <Route path="*" element={<HomePage />} />
                            </Routes>
                        </main>
                        <Footer />
                        <MobileActionBar />
                        <CartDrawer />
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                style: {
                                    background: "#0A0A0A",
                                    color: "#FFFFFF",
                                    border: "1px solid #FF5FA2",
                                    fontFamily: "Manrope, sans-serif",
                                },
                            }}
                        />
                    </SmoothScroll>
                </CartProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
